"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegacyInsightMenu = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var sdk_model_1 = require("@gooddata/sdk-model");
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var util_1 = require("@gooddata/util");
var LegacyInsightMenuItem_1 = require("./LegacyInsightMenuItem");
var downloadFile_1 = require("../../../../../_staging/fileUtils/downloadFile");
var alignPoints = [{ align: "bc tr", offset: { x: 2, y: 0 } }];
var ignoredOutsideClickClasses = ["#" + downloadFile_1.DOWNLOADER_ID];
exports.LegacyInsightMenu = function (_a) {
    var widget = _a.widget, items = _a.items, onClose = _a.onClose;
    var widgetRefValue = sdk_model_1.widgetRef(widget);
    var exportWidgetRefAsString = sdk_model_1.objRefToString(widgetRefValue);
    return (react_1.default.createElement(sdk_ui_kit_1.Bubble, { alignTo: ".s-dash-item-action-options-" + util_1.stringUtils.simplifyText(exportWidgetRefAsString), alignPoints: alignPoints, className: "bubble-light options-menu-bubble s-options-menu-bubble", closeOnOutsideClick: true, 
        // we need to ignore the "clicks" on the hidden downloader link to prevent the menu from closing
        // when the download starts (if the user opened it again before the download was ready)
        ignoreClicksOnByClass: ignoredOutsideClickClasses, onClose: onClose },
        react_1.default.createElement(sdk_ui_kit_1.ItemsWrapper, { smallItemsSpacing: true }, items.map(function (item) {
            // legacy menu does not support separators
            if (item.type !== "button") {
                return null;
            }
            return (react_1.default.createElement(LegacyInsightMenuItem_1.LegacyInsightMenuItem, { key: item.itemId, bubbleId: item.itemId, bubbleMessage: item.tooltip, className: item.className, isDisabled: item.disabled, title: item.itemName, onClick: item.onClick }));
        }))));
};
//# sourceMappingURL=index.js.map